/**
 * Ответы на частые вопросы для экрана поддержки. Числа берутся из общих
 * констант, чтобы текст не разошёлся с тем, что проверяет сервер.
 */
import { t } from '../i18n';
import {
  LIMITS,
  PROJECT_TTL_DAYS,
} from '@reels/shared/constants';

export interface FaqItem {
  question: string;
  /** Абзацы ответа. */
  answer: string[];
}

const megabytes = (bytes: number): number => Math.round(bytes / (1024 * 1024));
const minutes = (seconds: number): number => Math.round(seconds / 60);

export function getFaq(): readonly FaqItem[] {
  const params = {
    count: LIMITS.sources.maxCount,
    mb: megabytes(LIMITS.illustrationVideo.maxBytes),
    photo: megabytes(LIMITS.photo.maxBytes),
  };
  return [
    { question: t('faq.how.q'), answer: [t('faq.how.a1'), t('faq.how.a2')] },
    {
      question: t('faq.upload.q'),
      answer: [
        t('faq.upload.a1', { ...params, count: LIMITS.sources.maxCount, n: minutes(LIMITS.sources.maxDurationS) }),
        t('faq.upload.a2', { ...params, count: LIMITS.maxIllustrations, n: minutes(LIMITS.illustrationVideo.maxDurationS) }),
      ],
    },
    { question: t('faq.format.q'), answer: [t('faq.format.a1'), t('faq.format.a2')] },
    { question: t('faq.wait.q'), answer: [t('faq.wait.a1'), t('faq.wait.a2')] },
    { question: t('faq.price.q'), answer: [t('faq.price.a1'), t('faq.price.a2')] },
    { question: t('faq.reedit.q'), answer: [t('faq.reedit.a1'), t('faq.reedit.a2')] },
    { question: t('faq.storage.q'), answer: [t('faq.storage.a1', { n: PROJECT_TTL_DAYS }), t('faq.storage.a2')] },
    { question: t('faq.failed.q'), answer: [t('faq.failed.a1'), t('faq.failed.a2'), t('faq.failed.a3')] },
    { question: t('faq.rights.q'), answer: [t('faq.rights.a1')] },
  ];
}
